import { loaderAnimation } from "assests"
const Loader = () => {
    return (
        <div className="text-center mt-5">
            <img src={loaderAnimation} className="mx-auto" width={96} height={96}/>
            <p className="mb-0 text-lg font-bold">Report is being generated. Please wait...</p>
        </div>
    )
}
export default Loader